import { useState, useEffect, lazy, Suspense } from "react";
import "@/App.css";
import useLenis from "@/hooks/useLenis";
import Gate from "@/components/Gate";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import HeroVideo from "@/components/sections/HeroVideo";
import Hero from "@/components/sections/Hero";

// Below-the-fold, code-split so they load after the hero paints.
const Story = lazy(() => import("@/components/sections/Story"));
const LiveProduct = lazy(() => import("@/components/sections/LiveProduct"));
const Deal = lazy(() => import("@/components/sections/Deal"));
const UseOfFunds = lazy(() => import("@/components/sections/UseOfFunds"));
const Traction = lazy(() => import("@/components/sections/Traction"));
const Product = lazy(() => import("@/components/sections/Product"));
const Agentic = lazy(() => import("@/components/sections/Agentic"));
const Roadmap = lazy(() => import("@/components/sections/Roadmap"));
const Market = lazy(() => import("@/components/sections/Market"));
const Team = lazy(() => import("@/components/sections/Team"));
const DataRoom = lazy(() => import("@/components/sections/DataRoom"));
const NextSteps = lazy(() => import("@/components/sections/NextSteps"));

const SectionFallback = () => <div className="h-40" aria-hidden />;

function DealRoom() {
  useLenis(true);
  return (
    <div className="relative bg-ink min-h-screen">
      <div className="grain" />
      <Nav />
      <main className="relative z-10">
        <HeroVideo />
        <Hero />
        <Suspense fallback={<SectionFallback />}>
          <Story />
          <LiveProduct />
          <Deal />
          <UseOfFunds />
          <Traction />
          <Product />
          <Agentic />
          <Roadmap />
          <Market />
          <Team />
          <DataRoom />
          <NextSteps />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  const [authed, setAuthed] = useState(false);

  useEffect(() => {
    // VIP path, bypasses the password gate entirely.
    if (typeof window !== "undefined" && window.location.pathname.startsWith("/vip")) {
      setAuthed(true);
      return;
    }
    if (sessionStorage.getItem("utopia_token")) setAuthed(true);
  }, []);

  return (
    <div className="App">
      {authed ? <DealRoom /> : <Gate onUnlock={() => setAuthed(true)} />}
    </div>
  );
}

export default App;
